import { router, usePage } from '@inertiajs/react'
import { Impersonation, SharedProps } from '../../types'

// The persistent proof of who the operator really is, plus the way out. It has
// to render on every surface an impersonated session can reach — including the
// standalone Guide screens (company creation, workspace selection) that render
// without the main Layout.
export default function ImpersonationBanner({ impersonation }: { impersonation?: Impersonation | null }) {
  const page = usePage().props as unknown as SharedProps
  const active = impersonation ?? page.impersonation

  if (!active) return null

  const isGuide = active.mode === 'guide'
  const label = isGuide
    ? `Impersonating Guide: ${active.guide?.full_name ?? 'Unknown guide'}${active.organization ? ` — ${active.organization.name}` : ''}`
    : `Support mode: You are impersonating ${active.organization?.name ?? 'this company'}`

  return (
    <div
      role="status"
      className="bg-[#FFF3CD] border-b-2 border-[#B87A20] px-6 py-3 text-[#1B1B1B] flex items-center justify-center gap-4"
    >
      <strong>{label}</strong>
      <button
        type="button"
        onClick={() => router.delete(active.stop_path)}
        className="rounded-lg bg-[#1B1B1B] px-4 py-2 text-sm font-semibold text-white hover:bg-black"
      >
        {isGuide ? 'Stop impersonating' : 'Return to Super Admin'}
      </button>
    </div>
  )
}
